import { shallowEqual, useSelector } from 'react-redux';

const useIs12HoursTimeFormat = () => {
  const timeFormat = useSelector((state) => state?.auth?.getUserPreference?.data?.['timeFormat'], shallowEqual);
  return timeFormat == 12;
};

export default useIs12HoursTimeFormat;

//  Use this hook like following way

// const userDateFormat = useUserPreference(
//     USER_PREFERENCES.DEFAULT_DATE_FORMAT
//   );
